module.exports = __webpack_public_path__ + "static/media/4.9a5917a1.jpg";